(() => {
  function initLuno(root = document) {
    const product = root.querySelector('[data-el-product]');
    if (!product || product.dataset.elReady === 'true') return;

    const mainImage = product.querySelector('[data-el-main-image]');
    const variantSelect = product.querySelector('[data-el-variant]');
    const variantsNode = product.querySelector('[data-el-variants]');
    const addButton = product.querySelector('[data-el-add]');
    const addLabel = product.querySelector('[data-el-add-label]');
    const price = product.querySelector('[data-el-price]');
    const compare = product.querySelector('[data-el-compare]');
    const saving = product.querySelector('[data-el-saving]');
    const sticky = product.querySelector('[data-el-sticky]');
    const stickyPrice = product.querySelector('[data-el-sticky-price]');
    const stickyButton = product.querySelector('[data-el-sticky-add]');
    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      console.warn('Luno variant data could not be read.', error);
    }

    function showImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.srcset = '';
      if (alt) mainImage.alt = alt;
      product.querySelectorAll('[data-el-image]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.elImage === src));
      });
    }

    function selectedOptions() {
      return [...product.querySelectorAll('[data-el-option]')].map(group => {
        const selected = group.querySelector('[data-el-choice]:checked');
        const select = group.querySelector('[data-el-choice-select]');
        return selected?.value || select?.value || '';
      });
    }

    function setVariant(variant) {
      if (!variant || !variantSelect) return;
      variantSelect.value = String(variant.id);
      if (price) price.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
      }
      if (saving) {
        saving.textContent = variant.onSale ? `Save ${variant.saving}` : '';
        saving.hidden = !variant.onSale;
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addButton.dataset.availableLabel : addButton.dataset.soldLabel;
      if (variant.image) showImage(variant.image, variant.alt);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    product.querySelectorAll('[data-el-image]').forEach(button => {
      button.addEventListener('click', () => showImage(button.dataset.elImage, button.dataset.elAlt));
    });

    product.querySelectorAll('[data-el-choice]').forEach(input => {
      input.addEventListener('change', () => {
        const group = input.closest('[data-el-option]');
        const label = group?.querySelector('[data-el-option-label]');
        if (label) label.textContent = input.value;
        const options = selectedOptions();
        const variant = variants.find(item => item.options.every((value, index) => value === options[index]));
        setVariant(variant);
      });
    });

    product.querySelectorAll('[data-el-choice-select]').forEach(select => {
      select.addEventListener('change', () => {
        const options = selectedOptions();
        const variant = variants.find(item => item.options.every((value, index) => value === options[index]));
        setVariant(variant);
      });
    });

    const form = product.querySelector('.el-product-form');
    const bundle = form?.querySelector('kaching-bundle');
    if (form && bundle) {
      const syncBundle = () => {
        const ready = Boolean(bundle.querySelector('.kaching-bundles__block, input:not([type="hidden"]), select, [role="radio"]'));
        form.classList.toggle('el-product-form--bundled', ready);
      };
      new MutationObserver(syncBundle).observe(bundle, { childList: true, subtree: true, attributes: true });
      syncBundle();
    }

    if (sticky && addButton) {
      const observer = new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-90px 0px 0px' });
      observer.observe(addButton);
    }
    stickyButton?.addEventListener('click', () => addButton?.click());
    product.dataset.elReady = 'true';
  }

  function boot(root = document) {
    initLuno(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
